export const REMOVE_FILTER_ERROR = 'REMOVE_FILTER_ERROR';

export const removeError = () => async (dispatch) => {
  dispatch({ type: REMOVE_FILTER_ERROR });
};
